import { useEffect } from "react";
import { userService } from "../user/services/user.service";
import Intercom from "@intercom/messenger-js-sdk";

const INTERCOM_APP_ID = "goajk1j7";

export default function useFinMessenger(user) {
    useEffect(() => {
        if (!user || !user?.selectedOrganization?.externalUUID) {
            return;
        }

        let isMounted = true;

        const init = async () => {
            try {
                const token = await userService.getFinToken();
                if (!isMounted) {
                    return;
                }

                Intercom({
                    app_id: INTERCOM_APP_ID,
                    region: "eu",
                    intercom_user_jwt: token,
                    company: {
                        company_id: user.selectedOrganization.externalUUID,
                        company_name: user.selectedOrganization.name,
                        hs_company_object_id: user.selectedOrganization.hubspotId,
                        platform_uuid: user.selectedOrganization.externalUUID,
                    },
                });
            } catch (err) {
                console.error("Fin chat init failed:", err);
            }
        };

        init();

        return () => {
            isMounted = false;
        };
    }, [user, user?.selectedOrganization]);
}
